import * as clipboard from 'clipboard-polyfill';

class ClipboardHelper {
    public copyToClipboard(text: string) {
        clipboard.writeText(text);
    }
}

export const clipboardHelper = new ClipboardHelper();
